import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthContext'
import { ProtectedRoute } from '@/auth/ProtectedRoute'
import { CategoryPage } from '@/pages/CategoryPage'
import { ChangePassword } from '@/pages/ChangePassword'
import { CustomerIndex } from '@/pages/CustomerIndex'
import { CustomerLayout } from '@/pages/CustomerLayout'
import { Home } from '@/pages/Home'
import { Login } from '@/pages/Login'
import { AcceptInvite } from '@/pages/AcceptInvite'
import { ManageCategories } from '@/pages/ManageCategories'
import { ManageCustomers } from '@/pages/ManageCustomers'
import { MfaSetup } from '@/pages/MfaSetup'
import { SettingsOverview } from '@/pages/SettingsOverview'
import { FieldNamesSettings } from '@/pages/FieldNamesSettings'
import { AttachmentsSettings } from '@/pages/AttachmentsSettings'
import { BackupSettings } from '@/pages/BackupSettings'
import { AiSettings } from '@/pages/AiSettings'
import { AiSearch } from '@/pages/AiSearch'
import { Expiries } from '@/pages/Expiries'
import { ExpirySettings } from '@/pages/ExpirySettings'
import { TelegramSettings } from '@/pages/TelegramSettings'
import { ManageTemplates } from '@/pages/ManageTemplates'
import { SecuritySettings } from '@/pages/SecuritySettings'
import { LoginActivitySettings } from '@/pages/LoginActivitySettings'
import { UsersAdmin } from '@/pages/UsersAdmin'
import { SiteSettingsProvider } from '@/siteSettingsContext'

export default function App() {
  return (
    <BrowserRouter>
      <SiteSettingsProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />

            <Route element={<ProtectedRoute requireMfa={false} />}>
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/mfa/setup" element={<MfaSetup />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route index element={<Home />} />
              <Route path="customers" element={<Home />} />
              <Route path="settings" element={<SettingsOverview />} />
              <Route path="settings/field-names" element={<FieldNamesSettings />} />
              <Route path="settings/security" element={<SecuritySettings />} />
              <Route path="settings/attachments" element={<AttachmentsSettings />} />
              <Route path="settings/backups" element={<BackupSettings />} />
              <Route path="settings/ai" element={<AiSettings />} />
              <Route path="ai-search" element={<AiSearch />} />
              <Route path="settings/expiries" element={<ExpirySettings />} />
              <Route path="settings/telegram" element={<TelegramSettings />} />
              <Route path="expiries" element={<Expiries />} />
              <Route path="settings/login-activity" element={<LoginActivitySettings />} />
              <Route
                path="settings/site"
                element={<Navigate to="/settings/field-names" replace />}
              />
              <Route path="settings/templates" element={<ManageTemplates />} />
              <Route path="settings/templates/:key" element={<ManageTemplates />} />
              <Route path="users" element={<UsersAdmin />} />
              <Route path="manage-customers" element={<ManageCustomers />} />
              <Route path="manage-categories" element={<ManageCategories />} />
              <Route path="customers/:customerId" element={<CustomerLayout />}>
                <Route index element={<CustomerIndex />} />
                <Route
                  path="manage-categories"
                  element={<Navigate to="/manage-categories" replace />}
                />
                <Route path=":slug" element={<CategoryPage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </SiteSettingsProvider>
    </BrowserRouter>
  )
}
